module.exports = __webpack_public_path__ + "img/120ne.bc7d316c.svg";